module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-3-056cd758ace4f35b32a06e05b5651fec.jpg";